// import React, { useState, useRef, useEffect } from "react";

import ListItemTransform from "../../../../components/@documents/item_transform/ListItemTransform";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemTransformPage() {

    return (
        <ListItemTransform 
            routeType={routeTypes.retail}
        />
    )
}